import { DefaultSettings, settings } from '../../../settings/settings-util'
import reducer from './reducers/index'
import Renderers from './renderers/renderers'
import Mutators from "./renderers/mutator"
import {Store} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";
const reduceReducers = (reducers) =>
{
    return (previous, current) =>
        reducers.reduce(
            (p,r) => r(p, current), previous
        );
};

export default class InputBox
{
	public _settings: DefaultSettings;
	public _renderers: any;
	public _mutators: any;
	public _containerMutators: any;
	public _inputMutators: any;
	public _buttonMutators: any;
	public _children: any;
	public _store: Store<AlmeState> | null = null;
	public _m1: any;
	public _m2: any;
	public _m3: any;
	public _childs: any;
    public _suggestion: any;

    constructor(passedSettings?: DefaultSettings, containerMutators = [], inputMutators = [], buttonMutators = [], childComponents = [], suggestion = [])
    {
        this._settings = passedSettings || settings;
        this._suggestion = suggestion;
        this._renderers = new Renderers(this._settings, this._suggestion);
        this._mutators = new Mutators(this._settings);
        this._containerMutators = containerMutators;
        this._inputMutators = inputMutators;
        this._buttonMutators = buttonMutators;
        this._children = childComponents;
       
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer()
    {
        let reducers: any = [];

        this._children.forEach((item) => {
            reducers.push(item.getReducer());
        });

        reducers.push(reducer);

        return reduceReducers(reducers);
    }

    getRenderer()
    {
        return this._renderers.getRender();
    }

    getMutator()
    {
        return this._mutators.getMutate();
    }

    initialize(store)
    {
        this._mutators.initialize(this._store)
        this._inputMutators.push(this._mutators);

        this._m1 = [];
        this._m2 = [];
        this._m3 = [];
        this._childs = [];

        this._containerMutators.forEach((item) => {
            this._m1.push(item.getMutator());
        });

        this._inputMutators.forEach((item) => {
            this._m2.push(item.getMutator());
        });

        this._buttonMutators.forEach((item) => {
            this._m3.push(item.getMutator());
        });

        this._children.forEach((item) => {
            this._childs.push(item.getRenderer());
        });

        this._renderers.initialize(store, this._m1, this._m2, this._m3, this._childs);
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-inputbox/src/window-inputbox.ts